export const SET_PREVIEW_CUSTODIAN = "SET_PREVIEW_CUSTODIAN";
export const SET_PREVIEW_CUSTODIAN_SUCCESS = "SET_PREVIEW_CUSTODIAN_SUCCESS";
export const API_ERROR = "API_ERROR";
